<template>
    <CompassTooltip :arrow="false" class="tooltip">
        <template slot="content">
            <span>{{ fullFileName }}</span>
        </template>
        <div
            class="attachments-wrapper"
            :class="{ error_class: isErrorFile }"
            @click.prevent="handleClick"
        >
            <div class="attachments-wrapper__content">
                <div v-if="isErrorFile" class="round-icon">
                    <CompassIcon type="alert" size="extra-small" icon="close" />
                </div>
                <svg
                    v-else
                    class="file-icon"
                    :viewBox="fileType ? fileType.viewBox : defaultType && defaultType.viewBox"
                    v-html="fileType ? fileType.src : defaultType && defaultType.src"
                ></svg>
                <div class="attachments-wrapper__title typographies-paragraph-medium-semibold">
                    <span>{{ isErrorFile ? attachment.error_text : truncatedText }}</span>
                    <span v-if="!isErrorFile" class="light">
                        ({{ sizeConverter(attachment.size) }})
                    </span>
                </div>
                <div v-if="attachment.isFileLoaded" class="progress-bar__wrapper">
                    <div class="progress-bar">
                        <div class="progress-bar__progress"></div>
                    </div>
                </div>
            </div>
            <CompassIcon
                v-if="!removeBtn"
                :type="isErrorFile ? 'alert' : 'primary'"
                size="small"
                icon="close"
                class="close_icon"
                @click.stop="$emit('removeItem', attachment)"
            />
        </div>
    </CompassTooltip>
</template>

<script>
import { icons } from 'vcomponents/email/EmailAttachmentFileTypes';
import { acceptedFileTypes } from 'Config/authenticated/dictionary/emailAttachments';

export default {
    props: {
        attachment: {
            type: Object,
            default: () => {},
        },
        removeBtn: {
            type: Boolean,
            default: false,
        },
        canBeDownloaded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        formatedAttachmentExtension() {
            return this.attachment.extension.toLowerCase();
        },
        isErrorFile() {
            return this.attachment.error;
        },
        fullFileName() {
            return this.attachment.name + '.' + this.attachment.extension;
        },
        fileIcon() {
            const isKnownFileType = Object.keys(acceptedFileTypes).includes(
                this.formatedAttachmentExtension,
            );
            return isKnownFileType ? acceptedFileTypes[this.formatedAttachmentExtension].icon : '';
        },
        fileType() {
            return icons.find((file) => file.id === this.fileIcon);
        },
        defaultType() {
            return icons.find((file) => file.id === 'default');
        },
        isImageFile() {
            const imageFileExtensions = Object.entries(acceptedFileTypes)
                .filter(([key, value]) => value.icon === 'image')
                .map(([key]) => key);

            return imageFileExtensions.includes(this.formatedAttachmentExtension);
        },
        canOpenInNewTab() {
            return this.isImageFile || this.formatedAttachmentExtension === 'pdf';
        },
        truncatedText() {
            const maxLength = 25;
            if (this.attachment && this.attachment.name.length > maxLength) {
                return (
                    this.attachment.name.substring(0, maxLength) + '...' + this.attachment.extension
                );
            }
            return !this.attachment.isFileLoaded
                ? this.attachment.name + '.' + this.attachment.extension
                : this.attachment.name + this.attachment.extension;
        },
    },
    methods: {
        handleClick() {
            if (!this.attachment.error && this.canBeDownloaded) {
                if (this.canOpenInNewTab) {
                    window.open(this.attachment.public_link + '&display=Y', '_blank');
                } else {
                    window.open(this.attachment.public_link, '_blank');
                }
            }
        },
        sizeConverter(sizeInBytes) {
            const kilobyte = 1024;
            const megabyte = kilobyte * kilobyte;

            if (sizeInBytes < megabyte) {
                return (sizeInBytes / kilobyte).toFixed(2) + ' KB';
            } else {
                return (sizeInBytes / megabyte).toFixed(2) + ' MB';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.progress-bar__wrapper {
    width: 100%;
    margin: 0 var(--spacing-1) 0 var(--spacing-1);

    .progress-bar {
        border: none;
        position: relative;
        overflow: hidden;
        border-radius: var(--spacing-0);
        background-color: var(--colors-common-background-primary-disabled);
        width: 80px;
        height: 4px;

        &__progress {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            border-radius: var(--spacing-0);
            background-color: var(--colors-common-background-primary-default);
            animation: progress-animation 2s linear infinite;
        }
    }
}

@keyframes progress-animation {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}
.tooltip {
    margin-bottom: var(--spacing-1);
}

.attachments-wrapper {
    width: 440px;
    display: flex;
    align-items: center;
    padding: var(--spacing-1);
    justify-content: space-between;
    background-color: var(--colors-common-background-subtle);
    border-radius: var(--spacing-0);

    &__title {
        color: var(--colors-common-text-subtle-default);
        white-space: nowrap;
    }

    .close_icon {
        cursor: pointer;
    }

    .file-icon {
        flex-shrink: 0;
        height: 16px;
        width: 16px;
    }

    &__content {
        display: flex;
        align-items: center;
        width: 100%;

        svg {
            margin-right: 4px;
        }

        .light {
            color: #667080;
        }
    }
}
.error_class {
    background-color: var(--colors-common-background-alert-subtle);

    .round-icon {
        border: 1px solid var(--colors-common-icon-alert);
        border-radius: 50%;
        margin-right: var(--spacing-0);

        svg {
            margin-right: 0;
        }
    }

    span {
        color: var(--colors-common-icon-alert);
    }
}
</style>
